export type LoginDto = {
  username?: string;
  password?: string;
};

export enum TokenGrantType {
  PasswordRealm = 'password_realm',
  RefreshToken = 'refresh_token',
}

export const CLAIMS_TOKEN = 'http://facephi.com/identity/claims/';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ClaimsType = { [key in string]: any };

export enum ClaimsList {
  liveness = 'liveness',
  email = 'email',
  videoAssistance = 'enable_video',
  antifraud = 'antifraud',
  pad = 'pad',
  tenant = 'tenant',
  advancedTracking = 'advanced_tracking',
  activeLiveness = 'active_liveness',
  customerEvaluation = 'customer_evaluation',
  detailedScreen = 'detailedscreen',
}
